// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_2K0HA","logo":"index_logo_15YCB","logoAnimate":"index_logoAnimate_2KOIU","mainLogo":"index_mainLogo_1NSMm","version":"index_version_198Pg"};